import React, { useState, useEffect} from 'react';
import { connect, useDispatch, useSelector } from "react-redux";
import { Field, reduxForm } from "redux-form";
import {
    renderField,
    required,
    renderToggle,
    renderSelectField
} from "../../../utils/formValidations.js";
import { Groups, Group, FormFooter } from "../../../components/Form/Form.js"
import { getEgressProviders } from '../../../actions/actionEgressProvider.js';

let EgressProviderForm = (props) => {
    const { handleSubmit } = props
    const dispatch = useDispatch()
    const egress_providers = useSelector(state => state.egress_provider.egress_providers) || null
    const [showCurrentEgressProvider, setCurrentEgressProvider] = useState(false);

    useEffect(() => {
        if (props.fromUpdate) {
            dispatch(getEgressProviders({egress_provider_id: props.match.params.id}))
        }
    }, []);

    useEffect(() => {
        if (props.fromUpdate && egress_providers) {
            const currentProvider = props.match.params.id || null

            let currentEgressProvider = egress_providers.find(provider => provider.egress_provider_id === currentProvider);
            setCurrentEgressProvider(currentEgressProvider)
            props.initialize({
                egress_provider_id: currentEgressProvider.egress_provider_id,
                egress_provider_type: currentEgressProvider.egress_provider_type,
                enabled: currentEgressProvider.enabled,
                name: currentEgressProvider.name,
                is_managed: currentEgressProvider.is_managed,
                enable_new_managed_gateways: currentEgressProvider.enable_new_managed_gateways,
            });


        }
    }, [egress_providers]);

    return (
        <Groups onSubmit={handleSubmit(props.save)} section={props.section}>
            <Group title="general" description="general-description">
                <Field name="enabled"
                    id="enabled"
                    type="checkbox"
                    component={renderToggle}
                />
                <Field type="text"
                    name="name"
                    id="name"
                    component={renderField}
                    validate={required} required
                    disabled={showCurrentEgressProvider.is_managed}
                />
                <Field type="select"
                    name="egress_provider_type"
                    id="egress_provider_type"
                    component={renderSelectField}
                    clearable={false}
                    help="kb-26-1"
                    disabled={props.fromUpdate}
                    selectedValue={"Dropbox"}
                    validate={required} required>
                    <option value="">{"Select"}</option>
                    <option value='openvpn'>{"OpenVPN"}</option>
                    <option value='wireguard'>{"Wireguard"}</option>
                    <option value='custom'>{"Custom"}</option>
                </Field>
            </Group>
            {props.fromUpdate && showCurrentEgressProvider.is_managed && (
                <Group title="egress-plugin" description="egress-plugin-description">
                    <Field name="enable_new_managed_gateways"
                        id="enable_new_managed_gateways"
                        help="kb-26-14"
                        type="checkbox"
                        component={renderToggle}
                    />
                </Group>
            )}
            <FormFooter cancel={() => props.history.push("/egress_providers")} />
        </Groups>
    );
}

EgressProviderForm = reduxForm({
    form: 'EgressProviderForm'
})(EgressProviderForm)

EgressProviderForm = connect(  // eslint-disable-line
    state => ({
        initialValues: { enabled: true },
    })) 
(EgressProviderForm); 

export default EgressProviderForm
